<script>
  export let title = undefined;
  export let style = undefined;
  export let dimension = 60;

  let name = "wildfire";

  $: attributes = {
    width: dimension,
    height: dimension,
    role: title ? "img" : "presentation",
    ...(!title && { "aria-hidden": true }),
    ...(title && { "aria-labelledby": `icon-title-${name}` }),
    ...(style && { style }),
  };
</script>

<svg
  xmlns="http://www.w3.org/2000/svg"
  preserveAspectRatio="xMidYMid meet"
  viewBox="0 0 62 62"
  {...attributes}
>
  {#if title}
    <title id="{`icon-title-${name}`}">{title}</title>
  {/if}
  <defs>
    <radialGradient id="gradient-wildfire">
      <stop offset="0" style="stop-color:#C8C8C8;stop-opacity:0.3"></stop>
      <stop offset="0.5" style="stop-color:#C8C8C8;stop-opacity:0.5"></stop>
      <stop offset="1" style="stop-color:#C8C8C8;stop-opacity:0.3"></stop>
    </radialGradient>
  </defs>
  <circle style="fill:url(#gradient-wildfire)" r="30" cy="31" cx="31"></circle>
  <g>
    <path
      d="m 29.568093,4.5075714 0.949979,0 0,27.3118936 -1.79868,1.038468 0,10.361279 -2.069344,2.069344 -6.284875,-6.284876 -2.315574,2.315574 6.115489,6.115489 -6.234236,6.234236 -13.9528154,-13.952815 2.612442,-2.612442 6.4123574,6.412358 c 1.256534,0.237788 1.559174,-0.0061 2.152798,-0.414717 0.717795,-1.063222 0.826886,-1.2097 0.40027,-2.613341 L 6.0561155,28.732033 8.7279311,26.060218 19.949557,35.975622 c 1.465352,0.404584 2.069403,0.170873 2.999781,-0.100795 l 0.524273,-0.338575 c 0.707303,-0.524587 0.874316,-1.693205 1.22584,-2.613371 z"
      fill="#f1592a"
      stroke="none"></path>
    <path
      d="m 33.177038,4.5075714 -0.949979,0 0,27.3118946 1.79868,1.038468 0,10.361279 2.069344,2.069344 6.284875,-6.284877 2.315574,2.315575 -6.115489,6.115489 6.234236,6.234235 13.952815,-13.952815 -2.612442,-2.612441 -6.412357,6.412358 c -1.256534,0.237788 -1.559174,-0.0061 -2.152798,-0.414717 -0.717795,-1.063222 -0.826886,-1.2097 -0.40027,-2.613341 L 56.689016,28.732033 54.0172,26.060218 42.795574,35.975623 c -1.465352,0.404584 -2.069403,0.170873 -2.999781,-0.100795 L 39.27152,35.536253 c -0.707303,-0.524587 -0.874316,-1.693205 -1.22584,-2.613371 z"
      fill="#f1592a"
      stroke="none"></path>
    <path
      d="m 25.509109,58.379345 11.56123,0 -3.804118,-7.633325 -1.595918,-7.914232 -0.606049,-1.1e-5 -1.924023,8.014173 z"
      fill="#fcb041"
      stroke="none"></path>
    <path
      d="m 27.928094,59.22813 6.723259,0 c -1.937583,-2.628683 -1.866279,-4.636259 -3.370952,-8.21873 -1.425863,3.582038 -1.162062,5.648936 -3.352307,8.21873 z"
      fill="#f7941e"
      stroke="none"></path>
  </g>
</svg>
